<template>
  <div class="infinite-loading">
    <icon name="spinner" v-if="loading" />
    <slot v-else></slot>
  </div>
</template>

<script>
// Based on vue-infinite-loading
// MIT Copyright (c) 2016 PeachScript<scdzwyxst@gmail.com>
// https://github.com/PeachScript/vue-infinite-loading/blob/master/LICENSE

import { defineComponent } from 'vue'

/**
 * get the first scroll parent of an element
 * @param  {DOM} elm    the element which find scroll parent
 * @return {DOM}        the first scroll parent
 */
function getScrollParent (elm) {
  if (elm.tagName === 'BODY') {
    return window
  } else if (['scroll', 'auto'].indexOf(window.getComputedStyle(elm).overflowY) > -1) {
    return elm
  } else if (elm.hasAttribute('infinite-wrapper') || elm.hasAttribute('data-infinite-wrapper')) {
    return elm
  }
  return getScrollParent(elm.parentNode)
}

/**
 * get current distance from bottom
 * @param  {DOM}    scrollElm     scroll element
 * @param  {DOM}    infiniteElm   infinite element
 * @return {Number}     distance
 */
function getCurrentDistance (scrollElm, infiniteElm) {
  const infiniteElmOffsetTopFromBottom = infiniteElm.getBoundingClientRect().top
  const scrollElmOffsetTopFromBottom = scrollElm === window ? window.innerHeight : scrollElm.getBoundingClientRect().bottom
  return infiniteElmOffsetTopFromBottom - scrollElmOffsetTopFromBottom
}

export default defineComponent({
  props: {
    distance: {
      type: Number,
      default: 500,
    },
    loading: Boolean,
    complete: Boolean,
  },
  methods: {
    attemptLoad () {
      const currentDistance = getCurrentDistance(this.scrollParent, this.$el)
      if (!this.complete && currentDistance <= this.distance) {
        this.$emit('load')
      }
    },
    scrollHandler () {
      if (!this.loading) {
        this.attemptLoad()
      }
    }
  },
  mounted () {
    this.scrollParent = getScrollParent(this.$el)
    setTimeout(this.scrollHandler, 1)
    if (!this.complete) {
      this.scrollParent.addEventListener('scroll', this.scrollHandler)
    }
  },
  unmounted () {
    if (!this.complete) {
      this.scrollParent.removeEventListener('scroll', this.scrollHandler)
    }
  },
  watch: {
    complete (val, old) {
      if (val && !old) {
        this.scrollParent.removeEventListener('scroll', this.scrollHandler)
      }
      if (!val && old) {
        this.scrollParent.addEventListener('scroll', this.scrollHandler)
        this.$nextTick(this.scrollHandler)
      }
    }
  }
})
</script>
